import { createFileRoute } from '@tanstack/react-router';
import { OrganizationsPage } from '@/features/operator/organizations-page';

export const Route = createFileRoute('/operator/organizations/')({
    staticData: {
        crumbs: [{ label: 'shell.operatorConsole', to: '/operator' }, { label: 'operator.nav.organizations' }],
    },
    // `?provision=true` opens the provisioning form (the dashboard's quick action).
    validateSearch: (search: Record<string, unknown>): { provision?: boolean } =>
        search.provision === true || search.provision === 'true' ? { provision: true } : {},
    component: function OrganizationsRoute() {
        const { provision } = Route.useSearch();
        return <OrganizationsPage provision={provision ?? false} />;
    },
});
